var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 58,
    viewBox: "0 0 195 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63616",
    "data-name": "Group 63616",
    transform: "translate(-1106 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17536",
    "data-name": "Group 17536",
    transform: "translate(1157 530)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Title_TAG:H1_",
    "data-name": "Title [TAG:H1]",
    transform: "translate(0 11)",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    letterSpacing: "0.006em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Android app on")), /*#__PURE__*/React.createElement("text", {
    id: "Title_TAG:H1_2",
    "data-name": "Title [TAG:H1]",
    transform: "translate(0 12)",
    fontSize: 20,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Google Play"))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    transform: "translate(1106 520)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 58,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 194,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-google-play",
    "data-name": "Icon awesome-google-play",
    d: "M15.2,10.485,5.328.582,17.894,7.8l-2.69,2.69ZM2.75,0a1.74,1.74,0,0,0-.971,1.58V21.329a1.74,1.74,0,0,0,.971,1.58L14.233,11.452ZM21.779,10.1,19.143,8.57,16.2,11.457l2.94,2.887,2.69-1.526a1.8,1.8,0,0,0-.054-2.721ZM5.328,22.331l12.566-7.214-2.69-2.69Z",
    transform: "translate(1122.081 538)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGplay);
export default __webpack_public_path__ + "static/media/gplay.a332e188e31129d98d663b2cf01b5861.svg";
export { ForwardRef as ReactComponent };